/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {StreamBankMutableList} from "./StreamBankMutableList";

export const NoHeaderStreamBankMutableList = props => (
    <StreamBankMutableList
        className="sb-mutable-list-override-container-no-header"
        {...props}
    />
);
